import { ContentType } from "../../apiFunctions/sop/content_type";
import InputPanel from "./inputPanel";
import financials from "../../sop_templates/financials";
import templates from "../../sop_templates/templates";
import { useEffect, useState } from "react";
import { getCopiesFromHistoryIdAndContentTypeId } from "../../apiFunctions/sop/utils";
import { useAsyncEffect } from "rooks";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { setCopies, setInputs } from "../../store/sop/actions";
import { SOPCopyResult } from "../../apiFunctions/sop/content";
interface LeftSectionProps {
  contentType?: ContentType;
}

const LeftSection: React.FC<LeftSectionProps> = ({ contentType }) => {
  const router = useRouter();
  const [formData, setFormData] = useState<Object>();
  const dispatch = useDispatch();
  const { sopId } = router.query;

  useAsyncEffect(async () => {
    setFormData(
      templates.find((temp) => {
        return temp.endpoint == contentType?.content_name;
      })
    );

    const copies: SOPCopyResult = await getCopiesFromHistoryIdAndContentTypeId(
      contentType?.id ?? "",
      sopId as string
    );

    if (copies?.input_data) {
      dispatch(setInputs(copies?.input_data));
    }
    if (copies) {
      dispatch(setCopies(copies?.output_data));
    } else {
      dispatch(setCopies(undefined));
    }
  }, [contentType?.content_name]);

  return (
    <>
      {formData && (
        <div className="h-full flex flex-col px-3 lg:px-5  py-4 font-Inter">
          <InputPanel formFields={formData}></InputPanel>
          <p className="text-red-500 px-3 pt-2">
            * Indicates Required Question
          </p>
        </div>
      )}
    </>
  );
};

export default LeftSection;
